/* RIVE AZUR — shared behavior (rebrand 2026-07-28).
   Editor-safe: every init is idempotent + re-runs on shopify:section:load. */
(function () {
  function initHero(scope) {
    var root = scope.querySelector('[data-rvz-hero]');
    if (!root || root.dataset.rvzInit) return;
    root.dataset.rvzInit = '1';
    var variantInput = root.querySelector('[data-rvz-variant]');
    var planInput = root.querySelector('[data-rvz-plan]');
    var packs = Array.prototype.slice.call(root.querySelectorAll('[data-rvz-pack]'));
    var modes = Array.prototype.slice.call(root.querySelectorAll('[data-rvz-mode]'));
    var stickyPrice = document.querySelector('[data-rvz-sticky-price]');
    var priceNow = root.querySelector('[data-rvz-price-now]');
    var priceWas = root.querySelector('[data-rvz-price-was]');
    var subPer = Array.prototype.slice.call(root.querySelectorAll('[data-rvz-sub-price]'));
    var subOnly = Array.prototype.slice.call(root.querySelectorAll('[data-rvz-subonly]'));
    var atcPrice = root.querySelector('[data-rvz-atc-price]');
    var echo = root.querySelector('[data-rvz-echo]');
    var form = root.querySelector('form[action*="/cart/add"]');
    if (!variantInput || !packs.length) return;

    function currentPack() {
      for (var i = 0; i < packs.length; i++) if (packs[i].getAttribute('aria-checked') === 'true') return packs[i];
      return packs[0];
    }
    function currentMode() {
      for (var i = 0; i < modes.length; i++) if (modes[i].getAttribute('aria-checked') === 'true') return modes[i].dataset.rvzMode;
      return 'one';
    }
    function setMode(which) {
      modes.forEach(function (m) { m.setAttribute('aria-checked', m.dataset.rvzMode === which ? 'true' : 'false'); });
    }
    var userMode = null; // last mode the customer chose herself — auto flips never overwrite it
    function sync() {
      var pack = currentPack();
      var subOk = !!pack.dataset.planId;
      var mode = currentMode();
      modes.forEach(function (m) {
        if (m.dataset.rvzMode === 'sub') {
          m.disabled = !subOk;
          if (!subOk && mode === 'sub') { mode = 'one'; setMode('one'); }
        }
      });
      if (subOk && mode === 'one' && userMode !== 'one') { mode = 'sub'; setMode('sub'); }
      variantInput.value = pack.dataset.variantId;
      if (planInput) {
        if (mode === 'sub' && subOk) { planInput.value = pack.dataset.planId; planInput.disabled = false; }
        else { planInput.value = ''; planInput.disabled = true; }
      }
      var subActive = mode === 'sub' && subOk && !!pack.dataset.planPrice;
      var active = subActive ? pack.dataset.planPrice : pack.dataset.price;
      if (stickyPrice) stickyPrice.textContent = active;
      if (priceNow) priceNow.textContent = active;
      if (priceWas) {
        priceWas.textContent = pack.dataset.price;
        priceWas.hidden = !(subActive && pack.dataset.planPrice !== pack.dataset.price);
      }
      if (pack.dataset.planPer) subPer.forEach(function (el) { el.textContent = pack.dataset.planPer; });
      /* delivery-cadence clause: hidden on a pack with no plan (3 bottles), which is a
         one-time purchase and therefore has no repeating delivery to promise */
      subOnly.forEach(function (el) { el.style.display = subActive ? '' : 'none'; });
      /* cadence note follows the selected pack (only tiles whose plan matched by tube count carry data-cadence) */
      var noteText = root.querySelector('[data-rvz-subnote-text]');
      if (noteText && pack.dataset.cadence) noteText.textContent = pack.dataset.cadence;
      if (atcPrice) atcPrice.textContent = '— ' + active;
      if (echo) {
        var lb = pack.querySelector('.lb');
        if (lb) echo.textContent = lb.textContent.trim();
      }
    }
    packs.forEach(function (p) {
      p.addEventListener('click', function () {
        packs.forEach(function (x) { x.setAttribute('aria-checked', 'false'); });
        p.setAttribute('aria-checked', 'true');
        sync();
      });
    });
    modes.forEach(function (m) {
      m.addEventListener('click', function () { if (!m.disabled) { userMode = m.dataset.rvzMode; setMode(m.dataset.rvzMode); sync(); } });
    });

    /* one-time express lane: add the selected pack's variant (no selling plan)
       and go straight to checkout */
    var buyOne = root.querySelector('[data-rvz-buy-one]');
    var buyOneErr = root.querySelector('[data-rvz-buy-one-err]');
    if (buyOne) buyOne.addEventListener('click', function () {
      if (buyOne.dataset.busy) return;
      buyOne.dataset.busy = '1';
      if (buyOneErr) buyOneErr.hidden = true;
      var lb = buyOne.querySelector('.lb');
      var orig = lb ? lb.textContent : '';
      if (lb) lb.textContent = buyOne.dataset.waitText || 'One moment…';
      var pack = currentPack();
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: Number(pack.dataset.variantId), quantity: 1 })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed: ' + r.status);
        return r.json();
      }).then(function () {
        window.location.href = '/checkout';
      }).catch(function () {
        delete buyOne.dataset.busy;
        if (lb) lb.textContent = orig;
        if (buyOneErr) buyOneErr.hidden = false;
      });
    });
    sync();

    /* main ATC: add via AJAX and slide the cart drawer in; falls back to a
       normal submit (the /cart page) when the drawer isn't available */
    if (form) form.addEventListener('submit', function (e) {
      if (!(window.QueenCart && document.querySelector('[data-queen-drawer]'))) return;
      e.preventDefault();
      var btn = form.querySelector('button[type="submit"].rvz-atc');
      if (btn && btn.dataset.busy) return;
      if (btn) { btn.dataset.busy = '1'; btn.style.opacity = '.75'; }
      var done = function () { if (btn) { delete btn.dataset.busy; btn.style.opacity = ''; } };
      var payload = { id: Number(variantInput.value), quantity: 1 };
      if (planInput && !planInput.disabled && planInput.value) payload.selling_plan = Number(planInput.value);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      }).then(function (r) { if (!r.ok) throw new Error('add failed: ' + r.status); return r.json(); })
        .then(function () { return window.QueenCart.refresh(true); })
        .then(done)
        .catch(function () { done(); form.submit(); });
    });

    var sticky = root.querySelector('[data-rvz-sticky]');
    var stickyAtc = root.querySelector('[data-rvz-sticky-atc]');
    if (stickyAtc && form) stickyAtc.addEventListener('click', function () {
      if (form.requestSubmit) form.requestSubmit(); else form.submit();
    });
    /* sticky bar reveals once the customer has scrolled 25% of the page */
    if (sticky) {
      var onStickyScroll = function () {
        var max = document.documentElement.scrollHeight - window.innerHeight;
        sticky.classList.toggle('on', max > 0 && window.scrollY / max >= 0.25);
      };
      window.addEventListener('scroll', onStickyScroll, { passive: true });
      onStickyScroll();
    }
  }

  function initFaq(scope) {
    Array.prototype.slice.call(scope.querySelectorAll('[data-rvz-faq]')).forEach(function (wrap) {
      if (wrap.dataset.rvzInit) return;
      wrap.dataset.rvzInit = '1';
      var items = Array.prototype.slice.call(wrap.querySelectorAll('.rvz-faq-item'));
      items.forEach(function (item) {
        var btn = item.querySelector('.rvz-faq-btn');
        if (!btn) return;
        btn.addEventListener('click', function () {
          var open = item.classList.contains('open');
          items.forEach(function (x) {
            x.classList.remove('open');
            var b = x.querySelector('.rvz-faq-btn'); if (b) b.setAttribute('aria-expanded', 'false');
            var mm = x.querySelector('.m'); if (mm) mm.textContent = '+';
          });
          if (!open) {
            item.classList.add('open');
            btn.setAttribute('aria-expanded', 'true');
            var m = item.querySelector('.m'); if (m) m.textContent = '–';
          }
        });
      });
    });
  }

  function initReveals(scope) {
    var els = Array.prototype.slice.call(scope.querySelectorAll('.rvz-rv:not(.in)'));
    if (!els.length) return;
    if (window.matchMedia('(prefers-reduced-motion: no-preference)').matches && 'IntersectionObserver' in window) {
      var rio = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); rio.unobserve(e.target); } });
      }, { threshold: 0.12 });
      els.forEach(function (el) { rio.observe(el); });
    } else {
      els.forEach(function (el) { el.classList.add('in'); });
    }
  }


  /* All-media slider gallery: native scroll-snap track with clone slides at both
     ends for an infinite wrap. Thumbs/arrows scroll the track; a debounced scroll
     handler resolves the logical index and performs the silent edge jumps. */
  function initSliderGallery(gal) {
    var track = gal.querySelector('.rvz-galslides');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.querySelectorAll('[data-rvz-slide]'));
    var thumbs = Array.prototype.slice.call(gal.querySelectorAll('[data-rvz-thumb], [data-rvz-dot]'));
    var n = slides.length;
    if (n < 2) return;
    gal.dataset.rvzGalReady = '1';

    var firstClone = slides[0].cloneNode(true), lastClone = slides[n - 1].cloneNode(true);
    [firstClone, lastClone].forEach(function (c) {
      c.setAttribute('aria-hidden', 'true');
      c.removeAttribute('data-rvz-slide');
      c.classList.remove('is-on');
    });
    track.appendChild(firstClone);
    track.insertBefore(lastClone, slides[0]);

    function w() { return track.clientWidth || 1; }
    function jump(idx) { track.scrollTo({ left: (idx + 1) * w(), behavior: 'auto' }); }
    function go(idx) { track.scrollTo({ left: (idx + 1) * w(), behavior: 'smooth' }); }

    var i = 0, t = null;
    var strip = gal.querySelector('[data-rvz-thumbstrip]');
    function setActive(idx) {
      i = idx;
      thumbs.forEach(function (tb, k) {
        var on = k === i;
        tb.classList.toggle('is-on', on);
        if (on) tb.setAttribute('aria-current', 'true'); else tb.removeAttribute('aria-current');
      });
      if (strip && thumbs[i]) {
        var tb = thumbs[i];
        strip.scrollTo({ left: tb.offsetLeft - (strip.clientWidth - tb.clientWidth) / 2, behavior: 'smooth' });
      }
    }
    track.addEventListener('scroll', function () {
      if (t) clearTimeout(t);
      t = setTimeout(function () {
        var raw = Math.round(track.scrollLeft / w()); /* 0..n+1 in clone space */
        if (raw === 0) { jump(n - 1); setActive(n - 1); return; }
        if (raw === n + 1) { jump(0); setActive(0); return; }
        setActive(raw - 1);
      }, 90);
    }, { passive: true });

    thumbs.forEach(function (tb, k) {
      tb.addEventListener('click', function (e) { e.preventDefault(); go(k); });
    });
    var prev = gal.querySelector('[data-rvz-gal-prev]');
    var next = gal.querySelector('[data-rvz-gal-next]');
    if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); track.scrollBy({ left: -w(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function (e) { e.preventDefault(); track.scrollBy({ left: w(), behavior: 'smooth' }); });
    var main = gal.querySelector('.rvz-galmain');
    if (main) {
      main.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); track.scrollBy({ left: -w(), behavior: 'smooth' }); }
        if (e.key === 'ArrowRight') { e.preventDefault(); track.scrollBy({ left: w(), behavior: 'smooth' }); }
      });
    }
    window.addEventListener('resize', function () { jump(i); });
    requestAnimationFrame(function () { jump(0); });
  }

  /* Hero gallery: thumbs switch the main image, arrows step through, swipe on touch. */
  function initGallery(scope) {
    var gals = Array.prototype.slice.call(scope.querySelectorAll('[data-rvz-gal]'));
    if (scope.hasAttribute && scope.hasAttribute('data-rvz-gal')) gals.push(scope);
    gals.forEach(function (gal) {
      if (gal.dataset.rvzGalReady === '1') return;
      if (gal.classList.contains('rvz-gal--slider')) { initSliderGallery(gal); return; }
      var slides = Array.prototype.slice.call(gal.querySelectorAll('[data-rvz-slide]'));
      var thumbs = Array.prototype.slice.call(gal.querySelectorAll('[data-rvz-thumb]'));
      if (slides.length < 2) return;
      gal.dataset.rvzGalReady = '1';

      var i = 0;
      function show(n) {
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.classList.toggle('is-on', k === i); });
        thumbs.forEach(function (t, k) {
          var on = k === i;
          t.classList.toggle('is-on', on);
          if (on) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
        });
      }

      thumbs.forEach(function (t, k) {
        t.addEventListener('click', function (e) { e.preventDefault(); show(k); });
      });

      var prev = gal.querySelector('[data-rvz-gal-prev]');
      var next = gal.querySelector('[data-rvz-gal-next]');
      if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); show(i - 1); });
      if (next) next.addEventListener('click', function (e) { e.preventDefault(); show(i + 1); });

      var main = gal.querySelector('.rvz-galmain');
      if (main) {
        main.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowLeft') { e.preventDefault(); show(i - 1); }
          if (e.key === 'ArrowRight') { e.preventDefault(); show(i + 1); }
        });
        var x0 = null, y0 = null;
        main.addEventListener('touchstart', function (e) {
          if (e.touches.length !== 1) { x0 = null; return; }
          x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
        }, { passive: true });
        main.addEventListener('touchend', function (e) {
          if (x0 === null || !e.changedTouches.length) return;
          var dx = e.changedTouches[0].clientX - x0;
          var dy = e.changedTouches[0].clientY - y0;
          if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) show(dx < 0 ? i + 1 : i - 1);
          x0 = null;
        }, { passive: true });
      }

      show(0);
    });
  }

  function initAll(scope) { initHero(scope); initGallery(scope); initFaq(scope); initReveals(scope); }
  if (document.readyState !== 'loading') initAll(document);
  else document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
